export const TOP_FILTERS = [
  { param: 'top_pnl_24h', value: true, text: 'Топ PnL 24ч', fullText: 'Сортировка ставок от большего PnL к меньшему за 24 часа' },
  { param: 'top_trades_24h', value: true, text: 'Топ Ставки 24ч', fullText: 'Сортировка ставок от большей суммы ставки к меньшей за 24 часа' },
  { param: 'bet_value', value: 10000, text: 'Ставки >$10K 24ч', fullText: 'Фильтрация ставок больше $10,000' },
];

export const CATEGORIES = [
  { value: 'politics', text: 'Политика' },
  { value: 'crypto', text: 'Крипта' },
  { value: 'pop-culture', text: 'Культура' },
  { value: 'finance', text: 'Финансы' },
  { value: 'sports', text: 'Спорт' },
];

export const HEADER_ITEMS = [
  { text: 'Время', icon: null, align: 'start' },
  { text: 'Событие', icon: null, align: 'start' },
  { text: 'Кошелек', icon: null, align: 'start' },
  { text: 'Ставка', icon: null, align: 'start' },
  { text: 'Цена', icon: null, align: 'start' },
  { text: null, icon: 'arrow', align: 'center' },
  { text: 'Сейчас', icon: null, align: 'end' },
  { text: 'PnL', icon: null, align: 'end' },
];

export const CATEGORIES_STORAGE_KEY = 'polymarket_categories';

export const BOOKMARKS_COUNT_KEY = 'polymarket_bookmarks_count';

export const DEFAULT_CATEGORIES = ['politics', 'crypto', 'pop-culture', 'finance'];

export const PROVIDE_SCREEN_WIDTH_KEY = 'screen_width';